import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const ImageSlider = () => {
  const images = [
    "/images/banner/Temple gold.webp",
    "/images/banner/Ring.webp",
    "/images/banner/perfection.webp",
    "/images/banner/Mystic Curve.webp",
    "/images/banner/Earrings Design.webp",
    "/images/banner/Divine collection.webp",
    "/images/banner/Dancing wings.webp",
    "/images/banner/Dainty Shine.webp",
    "/images/banner/creation.webp",
    "/images/banner/crafted.webp",
    "/images/banner/bloom.webp",
    "/images/banner/bangle.webp",
    "/images/banner/Aura.webp",
    "/images/banner/art.webp",
  ];

  return (
    <div className="w-full h-[250px] md:h-[400px] lg:h-[550px]">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        navigation={false}
        breakpoints={{
          0: {
            // small screens
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            // md
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            // lg and above
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        className="h-full"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <img src={src} alt="slide" className="w-full h-full object-cover" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
